import { Card, CardContent } from '@crm/ui';
import { CalendarCheck, Percent, Receipt, Wallet } from 'lucide-react';
import { StatCard, WIDGET_GRID } from '@/components';
import { formatCurrency } from '@/lib/utils';
import { AppointmentStatusBadge } from '@/modules/schedule/components/status-badge';
import type { Kpis } from '../api';

/** Os quatro numeros do periodo, mais a quebra por status. */
export function KpiCards({
  kpis,
  showStatus = true,
  gridClassName = WIDGET_GRID.four,
  children,
}: {
  kpis: Kpis | undefined;
  /** A quebra por status e do relatorio; na home ela so alongava a pagina. */
  showStatus?: boolean;
  /** Colunas do bloco - muda quando outros numeros entram na mesma linha. */
  gridClassName?: string;
  /**
   * Numeros que dividem a linha com estes quatro. E assim que o painel junta
   * a operacao ao cashback: sete cartoes numa grade de sete, sem sobrar
   * celula vazia no fim.
   */
  children?: React.ReactNode;
}) {
  return (
    <div className="space-y-4">
      {/* Duas colunas ja no celular: quatro cartoes empilhados viram rolagem.
          Os quatro em linha so a partir do desktop: no tablet o rotulo longo
          bateria no icone em marca d'agua. */}
      <div className={gridClassName}>
        <StatCard
          title="Atendimentos"
          value={kpis?.total ?? 0}
          hint="Agendamentos no periodo"
          icon={<CalendarCheck className="h-4 w-4" />}
        />
        <StatCard
          title="Conversao"
          value={`${kpis?.conversionRate ?? 0}%`}
          hint="Concluidos sobre o total"
          icon={<Percent className="h-4 w-4" />}
        />
        <StatCard
          title="Vendas"
          value={formatCurrency(kpis?.revenue ?? 0)}
          hint="Somente atendimentos concluidos"
          icon={<Wallet className="h-4 w-4" />}
        />
        <StatCard
          title="Ticket medio"
          value={formatCurrency(kpis?.averageTicket ?? 0)}
          hint="Vendas dividido por atendimento"
          icon={<Receipt className="h-4 w-4" />}
        />

        {children}
      </div>

      {showStatus && kpis && kpis.byStatus.length > 0 ? (
        <section className="space-y-3">
          {/* No celular os selos coloridos com o numero ao lado ja se
              explicam - o rotulo era mais uma linha antes da lista. */}
          <h2 className="hidden text-sm font-medium text-muted-foreground sm:block">Por status</h2>

          <Card className="-mx-3 rounded-none border-x-0 bg-card sm:mx-0 sm:rounded-xl sm:border-x dark:bg-white/[0.06]">
            <CardContent>
              {/* A cor do status faz a leitura antes do texto: cancelado salta,
                concluido tranquiliza. */}
              <div className="flex flex-wrap gap-2">
                {kpis.byStatus.map((row) => (
                  <span key={row.status} className="flex items-center gap-1.5 text-sm">
                    <AppointmentStatusBadge status={row.status} />
                    <span className="font-medium">{row.count}</span>
                  </span>
                ))}
              </div>
            </CardContent>
          </Card>
        </section>
      ) : null}
    </div>
  );
}
